import { Box, Typography } from "@mui/material";
import { GridPagination, GridRowSelectionModel } from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";
import { common, input } from "../../i18n";

interface Props {
  selectionModel: GridRowSelectionModel;
}

export const PaginationWithRowSelected = ({
  selectionModel,
}: Props): JSX.Element => {
  const { t } = useTranslation([common, input], {
    nsMode: "fallback",
  });

  return (
    <Box
      display={"flex"}
      width={"100%"}
      alignItems={"center"}
      alignContent={"center"}
    >
      {selectionModel.length > 0 && selectionModel && (
        <Box paddingX={1}>
          <Typography variant="text2">
            {t("Row-Selected", {
              param: selectionModel.length,
            })}
          </Typography>
        </Box>
      )}

      <Box flex={1}>
        <GridPagination
          showFirstButton
          showLastButton
          labelRowsPerPage={t("rows-per-page")}
        />
      </Box>
    </Box>
  );
};
